<template>
  <div class="nosotros">
    <Header />
    <div class="contenedorNosotros">
      <img src="../assets/img/nosotros.jpg" />
      <div class="texto">
        <p>
          NEUMOMED ofrece una atención integral a los pacientes. Nuestro grupo
          médico con especialistas en Neumología y neurología son los más
          indicados para abordar al paciente respiratorio y dar solución a los
          trastornos del sueño.
        </p>
        <p>
          Nuestras sedes ubicadas en las ciudades de Medellín y Rionegro en
          Antioquía permiten la atención cómoda a nuestros pacientes facilitando
          el desplazamiento para las personas que viven en el oriente antioqueño
          y las del área metropolitana del Valle de Aburrá.
        </p>
        <p>
          NEUMOMED fue fundada en el 2010 con el objetivo de dar una solución
          integral a paciente respiratorio y convertirse en un centro de
          referencia en Antioquía para la atención a las enfermedades
          respiratorias y trastornos del sueño.
        </p>
      </div>
      <!-- <div class="convenios flex-container titulo-global">
        <h3>Actualmente tenemos convenios con:</h3>
        <div class="flex-row">
          <div class="flex-col-sm-6">
            <img src="../assets/img/sura.jpg" />
            <ul class="texto">
              <li>Póliza SURA y Medicina prepagada de SURA</li>
              <li>EPS SURA</li>
            </ul>
          </div>
          <div class="flex-col-sm-6">
            <img src="../assets/img/medplus.jpg" />
            <ul class="texto">
              <li>Medplus</li>
            </ul>
          </div>
          <p
            class="texto"
          >Si usted no pertenece a alguna de estas entidades no dude en preguntar por nuestros servicios tenemos planes para la atención a nuestros usuarios.</p>
        </div>
      </div>-->
    </div>
    <BotonesAgendar style="margin: 64px auto" />
    <!-- <Chat /> -->
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "../components/Header/Header.vue";
import Footer from "../components/Footer/Footer.vue";
import BotonesAgendar from "../components/BotonesAgendar/BotonesAgendar";
// import Chat from "../components/Chat/Chat";

export default {
  name: "nosotros",
  components: {
    Header,
    BotonesAgendar,
    // Chat,
    Footer
  }
};
</script>

<style lang="scss">
.contenedorNosotros {
  width: 700px;
  margin: 0 auto;
  img {
    margin-bottom: 24px;
    width: inherit;
  }
  p {
    margin-bottom: 24px;
  }

  .convenios {
    h3 {
      text-align: center;
      margin-bottom: 24px;
    }
    img {
      argin: 0 auto;
    }
    p {
      margin-top: 24px;
    }
  }
}
</style>
